import { render, staticRenderFns } from "./Aprazamento.vue?vue&type=template&id=6ba579a4&"
import script from "./Aprazamento.vue?vue&type=script&lang=js&"
export * from "./Aprazamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports